import { ProductCreation, ProductRaw } from '@Arti-zen/package-backoffice'
import styled from 'styled-components'
import { Theme } from 'theme/theme'

type TPprops = {
  products: ProductRaw[]
  newHeaders: Record<string, Set<string>>
  expectedColumns: (keyof ProductCreation)[]
}

const productColumns = {
  Désignation: 'description',
  Description: 'allDescription',
  'Prix facturé HT': 'price',
  Marge: 'coef',
  'Coût HT': 'netPrice',
  TVA: 'vat',
  Unité: 'unit',
  'ID Produit': 'id',
}

const productColumnsReverse = Object.fromEntries(Object.entries(productColumns).map(([key, value]) => [value, key]))

export default function ExempleProduct({ products, newHeaders, expectedColumns }: TPprops) {
  const newColumns = expectedColumns.map((prop) => [...newHeaders[prop]])
  return (
    <div>
      <p>Exemple avec les 10 premiers produits du fichier CSV :</p>
      <ExempleProductWrapper>
        <Row>
          {expectedColumns.map((col, index) => (
            <h3 key={`col-${index}`}>{productColumnsReverse[col]}</h3>
          ))}
        </Row>
        {products.map((product, index) => (
          <Row key={`product-exemple-${index}`}>
            {newColumns.map((columns) => {
              const values = columns
                .map((column) => product?.[productColumns[column]] ?? product?.[column])
                .filter(Boolean)
                .join(' - ')

              return <>{values ? <p>{values.length > 50 ? `${values.slice(0, 50)}...` : values}</p> : <p>_</p>}</>
            })}
          </Row>
        ))}
      </ExempleProductWrapper>
    </div>
  )
}

const ExempleProductWrapper = styled.div`
  padding: 10px;
  border: 1px solid ${Theme.colors.blueArtizen};
  border-radius: 5px;
  text-align: center;
  h3 {
    margin: 5px 0 0 0;
    font-size: 15px;
    flex: 1;
  }
  p {
    flex: 1;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
  align-items: center;
`
